import styled, { createGlobalStyle } from "styled-components";

/* ─────────────────────────────────────────────
   Loads the two typefaces the reference design uses.
   Scoped to this page (createGlobalStyle, rendered once
   from index.jsx) rather than touching index.html — falls
   back to system sans-serif if the network request fails.
───────────────────────────────────────────── */
// export const GlobalFontStyle = createGlobalStyle`
//     @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Plus+Jakarta+Sans:wght@600;700;800&display=swap');
// `;

export const GlobalFontStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Plus+Jakarta+Sans:wght@600;700;800&display=swap');

    .coffeee-plus-detail-modal-wrap {
        display: flex !important;
        align-items: flex-start !important;
        justify-content: center !important;
        padding: 28px 16px !important;
    }

    .coffeee-plus-detail-modal-wrap .ant-modal {
        top: 0;
        padding-bottom: 0;
        max-width: calc(100vw - 32px);
        margin: 0 auto !important;
    }

    .coffeee-plus-detail-modal-wrap .ant-modal-content {
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 28px 70px rgba(24, 33, 61, 0.2);
        padding: 0;
        max-height: calc(100vh - 56px);
        display: flex;
        flex-direction: column;
    }

    .coffeee-plus-detail-modal-wrap .ant-modal-body {
        padding: 22px 24px 24px;
        overflow-y: auto;
        max-height: calc(100vh - 56px);
    }

    /* Close (X): a 42px circle in the modal's top-right corner. antd sizes
       this button 22px by default, so it is sized to the circle here and
       antd's own grey hover square is turned off. It sits on the
       non-scrolling modal frame (only the body scrolls), so it stays
       visible, and 22px from the right keeps it clear of the scrollbar. */
    .coffeee-plus-detail-modal-wrap .ant-modal .ant-modal-close {
        top: 18px;
        right: 22px;
        inset-inline-end: 22px;
        width: 42px;
        height: 42px;
        padding: 0;
        border-radius: 50%;
        background: transparent !important;
        z-index: 10; /* stays on top of the scrolling body */
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .coffeee-plus-detail-modal-wrap .ant-modal .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media (max-width: 600px) {
        .coffeee-plus-detail-modal-wrap .ant-modal .ant-modal-close {
            top: 12px;
            right: 14px;
            inset-inline-end: 14px;
            width: 38px;
            height: 38px;
        }
    }
`;

/* ─────────────────────────────────────────────
   Palette — lifted directly from the reference's globals.css
   (deep indigo/purple brand gradient, #f5f6fc canvas, #4d42e9
   accent, #eceaff chip background).
───────────────────────────────────────────── */
const C = {
    ink: "#18213D",
    ink2: "#141D3C",
    muted: "#78839F",
    muted2: "#687492",
    muted3: "#7D87A4",
    eyebrow: "#747DA1",
    eyebrowSep: "#B3B8CB",
    accent: "#4D42E9",
    chipBg: "#ECEAFF",
    chipText: "#5145DF",
    cardBorder: "#E4E7F2",
    searchCardBorder: "#E1DEFA",
    fieldBorder: "#DCE1EF",
    fieldBg: "#FFFFFF",
    fieldFocusBorder: "#594FF0",
    gradientDarkFrom: "#211954",
    gradientDarkTo: "#30236F",
    gradientBtnFrom: "#5A45EE",
    gradientBtnTo: "#7B35E9",
    canvas: "#F5F6FC",
    danger: "#DC2626",
    detailCellBg: "#F7F8FC",
};

export const PageWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    background: ${C.canvas};
    font-family: "DM Sans", "Segoe UI", sans-serif;
`;

export const ContentWrap = styled.div`
    flex: 1;
    min-width: 0;
    padding: 16px 36px 24px;
    box-sizing: border-box;
    color: ${C.ink};
`;

/* ── Header ── */
export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;
    flex-wrap: wrap;
    gap: 12px;
`;

export const Eyebrow = styled.div`
    font-size: 11px;
    letter-spacing: 0.13em;
    font-weight: 700;
    color: ${C.eyebrow};
    text-transform: uppercase;

    span {
        padding: 0 7px;
        color: ${C.eyebrowSep};
    }
`;

export const HeaderTitle = styled.h1`
    font-family: "Plus Jakarta Sans", "DM Sans", sans-serif;
    font-weight: 800;
    font-size: 26px;
    margin: 4px 0 2px;
    color: ${C.ink2};
`;

export const HeaderSubtitle = styled.p`
    margin: 0;
    color: ${C.muted};
    font-size: 14px;
`;

/* ── Search card ── */
export const SearchCard = styled.div`
    border: 1px solid ${C.searchCardBorder};
    border-radius: 24px;
    background: #fff;
    box-shadow: 0 18px 45px rgba(35, 27, 105, 0.12);
    overflow: hidden;
    margin-bottom: 24px;
`;

export const SearchCardHeading = styled.div`
    padding: 26px 30px;
    background: linear-gradient(135deg, ${C.gradientDarkFrom} 0%, ${C.gradientDarkTo} 100%);
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    @media (max-width: 700px) {
        padding-left: 20px;
        padding-right: 20px;
    }
`;

export const SearchCardHeadingTitle = styled.h2`
    font-family: "Plus Jakarta Sans", "DM Sans", sans-serif;
    font-weight: 700;
    font-size: 18px;
    margin: 0 0 6px;
    color: #fff;
`;

export const SearchCardHeadingSubtitle = styled.p`
    margin: 0;
    color: #C8C3E8;
    font-size: 14px;
`;

export const SearchBadge = styled.span`
    display: flex;
    align-items: center;
    gap: 7px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.22);
    color: #fff;
    border-radius: 999px;
    padding: 9px 14px;
    font-size: 12px;
    font-weight: 700;
`;

export const FilterGrid = styled.div`
    display: grid;
    grid-template-columns: 1.3fr 1fr 1fr 1.3fr;
    gap: 15px;
    padding: 28px 30px 24px;

    @media (max-width: 900px) {
        grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
    @media (max-width: 700px) {
        padding-left: 20px;
        padding-right: 20px;
    }
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
`;

export const FieldLabel = styled.span`
    color: ${C.muted2};
    font-size: 12px;
    font-weight: 700;
`;

/* Forces every Select/InputNumber in the filter grid to the same 44px
   height (matching the reference's `.field select,.field input{height:44px}`),
   using the same deep-selector-override technique already relied on
   elsewhere in this app to normalize Ant Design's own internal sizing. */
/* CURSOR / CARET POSITIONING NOTES
   --------------------------------
   Single-mode Selects: the search wrapper is absolutely positioned inside
   the selector, so we pin it to 13px left/right to match the padding.

   Multiple / tags Selects (Role Name, Skills): the search wrapper lives
   INSIDE .ant-select-selection-overflow as a normal-flow item. It must stay
   in flow (NOT absolute, NOT flex) with zero margin, so the caret starts at
   the selector's 13px padding. The placeholder is absolutely positioned by
   Ant, so we pin it to the same 13px explicitly. Vertical centering comes
   from the overflow row's align-items: center. */
export const FieldBox = styled.div`
    width: 100%;

    .ant-select-selector,
    .ant-input-number {
        width: 100% !important;
        height: 44px !important;
        border-radius: 9px !important;
        border: 1px solid ${C.fieldBorder} !important;
        background: ${C.fieldBg} !important;
        box-shadow: none !important;
        display: flex;
        align-items: center;
    }

    .ant-select-selector {
        padding: 0 13px !important;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .ant-select-selector::-webkit-scrollbar {
        height: 3px;
    }

    .ant-select-selector::-webkit-scrollbar-thumb {
        background: #C7D2FE;
        border-radius: 10px;
    }

    /* Multiple / tags: Ant wraps content and adds an ::after spacer, which makes the
       content taller than the 44px box. With overflow-y hidden, focusing then scrolls
       the content up (placeholder jumps up, text looks squeezed). Disable both. */
    .ant-select-multiple .ant-select-selector {
        flex-wrap: nowrap !important;
        align-content: center !important;
        overflow-y: hidden !important;
    }

    .ant-select-multiple .ant-select-selector::after {
        display: none !important;
    }

    .ant-select-multiple .ant-select-selection-overflow {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        margin: 0 !important;
    }

    .ant-input-number-input {
        height: 42px !important;
        line-height: 42px !important;
        font: 500 13px "DM Sans", sans-serif;
        padding: 0 13px;
    }

    .ant-select-selection-item,
    .ant-select-selection-placeholder {
        height: 42px !important;
        line-height: 42px !important;
        display: flex;
        align-items: center;
        font: 500 13px "DM Sans", sans-serif;
        color: #293451;
    }

    /* ── Single mode: search wrapper is absolute, pinned to the 13px padding ── */
    .ant-select-single .ant-select-selection-search {
        position: absolute !important;
        left: 13px !important;
        right: 13px !important;
        top: 0 !important;
        bottom: 0 !important;
        margin: 0 !important;
    }

    .ant-select-single .ant-select-selection-search-input {
        width: 100% !important;
    }

    /* ── Multiple / tags: keep search IN FLOW, no horizontal offset ── */
    .ant-select-multiple .ant-select-selection-overflow {
        display: flex !important;
        flex-wrap: nowrap !important;
        align-items: center !important; /* vertical centering lives here */
        min-height: 42px;
        height: 42px;
    }

    .ant-select-multiple .ant-select-selection-overflow-item {
        align-self: center;
    }

    .ant-select-multiple .ant-select-selection-search {
        position: relative !important; /* NOT absolute */
        left: auto !important;
        right: auto !important;
        top: auto !important;
        bottom: auto !important;
        display: flex !important; /* in-flow flex row, aligned to the LEFT (no horizontal shift) */
        align-items: center !important;
        justify-content: flex-start !important;
        height: 42px !important;
        margin: 0 !important; /* kills Ant's margin-inline-start */
        margin-inline-start: 0 !important;
        padding: 0 !important;
        line-height: 0 !important;
    }

    .ant-select-multiple .ant-select-selection-search-input {
        display: block !important; /* removes inline baseline gap that made content taller than the box */
        flex: none !important;
        vertical-align: top !important;
    }

    .ant-select-multiple .ant-select-selection-overflow-item {
        display: flex !important;
        align-items: center !important;
        height: 42px !important;
        line-height: 0;
    }

    /* Input itself: no padding/margin so the caret starts at the wrapper's left edge.
       Do NOT force width here in multiple mode — Ant sizes it from a hidden mirror. */
    .ant-select-selection-search-input {
        height: 42px !important;
        line-height: 42px !important;
        padding: 0 !important;
        margin: 0 !important;
        border: 0 !important;
        outline: none !important;
        background: transparent !important;
        font: 500 13px "DM Sans", sans-serif !important;
        color: #293451;
    }

    /* Placeholder (multiple / tags): same 13px start as the caret, vertically centered */
    .ant-select-multiple .ant-select-selection-placeholder {
        position: absolute !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        height: auto !important;
        line-height: 1.5 !important;
        display: block !important;
        inset-inline-start: 13px !important;
        inset-inline-end: 13px !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /* Selected chips in multiple / tags mode */
    .ant-select-multiple .ant-select-selection-item {
        height: 26px !important;
        line-height: 24px !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .ant-select-focused .ant-select-selector,
    .ant-input-number-focused {
        border-color: ${C.fieldFocusBorder} !important;
        box-shadow: 0 0 0 3px rgba(89, 79, 240, 0.12) !important;
    }

    .ant-select-selector:hover,
    .ant-input-number:hover {
        border-color: #B5AEF5 !important;
    }
`;

export const RangeRow = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;

    > ${FieldBox} {
        flex: 1;
        min-width: 0;
    }
`;

export const RangeSeparator = styled.span`
    font-style: normal;
    color: #9AA3BA;
    flex-shrink: 0;
`;

export const FieldError = styled.p`
    margin: 2px 0 0;
    font-size: 12px;
    color: ${C.danger};
`;

export const SearchActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 0 30px 30px;

    @media (max-width: 700px) {
        padding-left: 20px;
        padding-right: 20px;
    }

    /* Both buttons are plain antd <Button>s; these deep overrides give
       them the reference's outline / gradient-primary treatment without
       hand-rolling a button component. */
    .ant-btn {
        height: 40px;
        border-radius: 8px;
        font-weight: 700;
        font-size: 13px;
        display: inline-flex;
        align-items: center;
        gap: 7px;
        box-shadow: none;
    }

    .ant-btn-default {
        border: 1px solid ${C.fieldBorder};
        background: #fff;
        color: ${C.muted2};
    }

    .ant-btn-default:hover {
        color: ${C.accent};
        border-color: #B5AEF5;
    }

    .ant-btn-primary {
        background: linear-gradient(135deg, ${C.gradientBtnFrom}, ${C.gradientBtnTo});
        border: 0;
        box-shadow: 0 10px 20px rgba(91, 62, 232, 0.25);
    }

    .ant-btn-primary:hover {
        background: linear-gradient(135deg, #4C38DD, #6828D3) !important;
        transform: translateY(-1px);
    }
`;

/* ── Results header ── */
export const ResultsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 14px;
    margin: 0 0 16px;
    scroll-margin-top: 16px;
`;

export const ResultsTitle = styled.h2`
    font-family: "Plus Jakarta Sans", "DM Sans", sans-serif;
    font-weight: 800;
    font-size: 22px;
    margin: 6px 0 0;
    color: ${C.ink2};
`;

export const ResultsCount = styled.span`
    background: ${C.chipBg};
    color: ${C.chipText};
    border-radius: 999px;
    padding: 7px 12px;
    font-size: 12px;
    font-weight: 700;
`;

/* ── Candidate card grid ── */
/* Exactly 3 cards per row on desktop. (auto-fill + minmax(280px) let the
   browser pick the column count from the width, so on the now full-width
   results area it no longer produced the original 3-up layout.) */
export const CandidateGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    width: 100%;
    align-items: stretch;

    @media (max-width: 900px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

/* Each card is a 5-row subgrid of the results grid: header, info row,
   skills, score panel, footer. Cards in the same grid row share these row
   heights, so the score panels and the bottom actions start at the same
   height in every card, however many skill chips or contact lines a
   candidate has. Every card always renders all 5 sections (see index.jsx). */
export const CANDIDATE_CARD_ROWS = 5;

export const CandidateCard = styled.article`
    position: relative;
    display: grid;
    grid-row: span ${CANDIDATE_CARD_ROWS};
    grid-template-rows: subgrid;
    row-gap: 0;
    align-content: start;
    background: #fff;
    border: 1px solid ${C.cardBorder};
    border-radius: 20px;
    padding: 20px 20px 18px;
    box-shadow: 0 10px 26px rgba(37, 32, 92, 0.07);
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
    min-width: 0;

    /* Content sits at the top of its shared row; spare space in a shorter
       section is left below it, so the next section still lines up. */
    & > * {
        align-self: start;
        min-width: 0;
    }

    &:hover {
        border-color: #C4BFFF;
        box-shadow: 0 14px 30px rgba(53, 44, 230, 0.12);
        transform: translateY(-2px);
    }

    /* Browsers without subgrid: plain column. */
    @supports not (grid-template-rows: subgrid) {
        display: flex;
        flex-direction: column;
        grid-row: auto;
    }
`;
export const CandidateTop = styled.div`
    display: flex;
    align-items: center;
    gap: 13px;
`;

const AVATAR_PALETTE = [
    "#5A45EE", "#7B35E9", "#4D42E9", "#FF2F89", "#30236F", "#8B5CF6",
];

const hashStr = (str) => {
    let h = 5381;
    for (let i = 0; i < (str || "").length; i++) {
        h = ((h << 5) + h) ^ str.charCodeAt(i);
        h = h & h;
    }
    return Math.abs(h);
};

export const getAvatarColor = (name) => AVATAR_PALETTE[hashStr(name || "") % AVATAR_PALETTE.length];

export const Avatar = styled.div`
    width: ${({ $size }) => $size || 52}px;
    height: ${({ $size }) => $size || 52}px;
    flex-shrink: 0;
    border-radius: ${({ $round }) => ($round === false ? "16px" : "50%")};
    background: ${({ $bg }) => $bg || "#5A45EE"};
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Plus Jakarta Sans", "DM Sans", sans-serif;
    font-weight: 700;
    font-size: ${({ $size }) => ($size ? Math.round($size * 0.36) : 18)}px;
    overflow: hidden;
`;

export const CandidateTitleWrap = styled.div`
    min-width: 0;
    flex: 1;
`;

export const CandidateName = styled.h3`
    margin: 0;
    color: ${C.ink};
    font-family: "Plus Jakarta Sans", "DM Sans", sans-serif;
    font-weight: 700;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CandidateRole = styled.p`
    margin: 4px 0 8px;
    color: ${C.muted3};
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CompanyTag = styled.span`
    display: inline-block;
    background: ${C.chipBg};
    color: ${C.chipText};
    border-radius: 999px;
    padding: 3px 10px;
    font-size: 11px;
    font-weight: 700;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CandidateMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin: 14px 0 12px;
    color: #697491;
    font-size: 12px;
`;

export const MetaItem = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
    background: ${C.detailCellBg};
    border-radius: 999px;
    padding: 5px 10px;
    color: #46506B;
`;

export const MetaCtc = styled.strong`
    margin-left: auto;
    color: ${C.accent};
    font-weight: 700;
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    white-space: nowrap;

    small {
        font-size: 10px;
        color: #9AA3BB;
        font-weight: 500;
    }
`;

/* ── Match % badge — no longer used on the card (the score lives in the
   score panel); kept so nothing else that imports it breaks. ── */
export const MatchBadge = styled.div`
    position: absolute;
    top: 14px;
    right: 14px;
    background: ${C.chipBg};
    color: ${C.chipText};
    font-weight: 800;
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 999px;
    white-space: nowrap;
    z-index: 1;
    letter-spacing: 0.02em;
`;

/* ── Email/phone row. ── */
export const ContactRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin: 12px 0 0;
    font-size: 12px;
    color: #697491;
`;

export const ContactItem = styled.span`
    display: flex;
    align-items: center;
    gap: 5px;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

/* ── "Insights" chip row — Expected CTC. ── */
export const InsightsRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 12px 0 0;
`;

export const InsightChip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: ${C.detailCellBg};
    color: #46506B;
    font-size: 11.5px;
    font-weight: 500;
    padding: 6px 11px;
    border-radius: 10px;
    white-space: nowrap;

    b {
        color: ${C.ink};
        font-weight: 700;
    }
`;

export const SkillPillRow = styled.div`
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    min-width: 0;
`;

export const SkillPill = styled.span`
    background: ${C.chipBg};
    color: ${C.chipText};
    border-radius: 999px;
    padding: 5px 10px;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
    /* A long skill name is cut with "…" instead of spilling out of the card. */
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
`;

export const SkillMore = styled(SkillPill).attrs({ as: "span" })`
    background: transparent;
    color: ${C.accent};
    padding: 5px 4px;
`;

export const CandidateBottom = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid #EDF0F7;
    color: #8791AA;
    font-size: 12px;
    gap: 8px;
    flex-wrap: wrap;
`;

export const ExpectedCtc = styled.span`
    b {
        color: ${C.ink};
    }
`;

export const CardActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    width: 100%;
    justify-content: flex-end;
`;

export const CardLinkButton = styled.button`
    border: 1px solid ${C.fieldBorder};
    background: #fff;
    padding: 7px 12px;
    border-radius: 10px;
    color: ${({ $muted }) => ($muted ? C.muted2 : C.ink)};
    font-weight: 700;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    text-decoration: none;
    transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;

    &:hover {
        border-color: #B5AEF5;
        color: ${C.accent};
        background: #F7F6FE;
        text-decoration: none;
    }
`;

export const PrimaryAction = styled.button`
    border: 0;
    background: linear-gradient(135deg, ${C.gradientBtnFrom} 0%, ${C.gradientBtnTo} 100%);
    color: #fff;
    font-weight: 700;
    font-size: 12.5px;
    padding: 8px 14px;
    border-radius: 10px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    box-shadow: 0 6px 14px rgba(91, 62, 232, 0.22);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    ${({ $fill }) => $fill && "flex: 1;"}

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 8px 18px rgba(91, 62, 232, 0.28);
        color: #fff;
    }
`;

export const GhostAction = styled(CardLinkButton)`
    background: #fff;
`;

/* ═════════════════════════════════════════════
   Candidate card redesign — header, info row, skills,
   four-cell score panel and footer.
═════════════════════════════════════════════ */

/* 1 · Header: avatar + identity (name, buttons, revealed contact) */
export const CardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 14px;
    min-width: 0;
`;

export const CardIdentity = styled.div`
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const CardName = styled.h3`
    margin: 0;
    max-width: 100%;
    color: ${C.ink};
    font-family: "Plus Jakarta Sans", "DM Sans", sans-serif;
    font-weight: 800;
    font-size: 20px;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        color: ${C.accent};
    }
`;

export const CardButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 9px;
`;

/* Rounded pill button: solid purple gradient ($solid) or purple outline. Works
   as a <button> or, with as="a", as a link. */
export const PillButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 34px;
    padding: 0 14px;
    border-radius: 999px;
    border: 1px solid ${({ $solid }) => ($solid ? "transparent" : "#B8A9F2")};
    background: ${({ $solid }) =>
        $solid ? `linear-gradient(135deg, ${C.gradientBtnFrom} 0%, ${C.gradientBtnTo} 100%)` : "#fff"};
    color: ${({ $solid }) => ($solid ? "#fff" : C.chipText)};
    box-shadow: ${({ $solid }) => ($solid ? "0 6px 14px rgba(91, 62, 232, 0.22)" : "none")};
    font: 700 12.5px "DM Sans", "Segoe UI", sans-serif;
    white-space: nowrap;
    text-decoration: none;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease,
        background 0.15s ease, color 0.15s ease;

    .anticon {
        font-size: 14px;
    }

    &:hover:not(:disabled) {
        text-decoration: none;
        ${({ $solid }) =>
            $solid
                ? `
            color: #fff;
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(91, 62, 232, 0.3);
        `
                : `
            color: ${C.accent};
            border-color: #8E7CF0;
            background: #F7F6FE;
        `}
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        box-shadow: none;
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
    }
`;

export const ContactReveal = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 100%;
    margin-top: 9px;
    color: #46506B;
    font-size: 12px;

    .anticon {
        color: ${C.accent};
    }
`;

/* 2 · Info row: role · qualification · experience · location */
export const InfoRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 6px;
    margin-top: 16px;
    color: #46506B;
    font-size: 12.5px;
`;

export const InfoItem = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    max-width: 100%;

    .anticon {
        color: #6B6F8F;
        font-size: 14px;
        flex-shrink: 0;
    }

    span {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 240px;
    }

    /* small dot separator between items */
    & + &::before {
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #C9CEDD;
        margin: 0 12px;
        flex-shrink: 0;
    }
`;

/* 3 · Skills */
export const SkillsSection = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid #EDF0F7;
`;

export const SkillsLabel = styled.span`
    color: ${C.ink};
    font-size: 12.5px;
    font-weight: 700;
`;

export const MutedDash = styled.span`
    color: #B3B8CB;
    font-size: 13px;
    font-weight: 600;
`;

/* 4 · Score panel — four equal cells in one rounded lavender container */
export const ScorePanel = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    margin-top: 14px;
    padding: 12px 4px;
    background: #F3F2FB;
    border: 1px solid #ECEAF8;
    border-radius: 14px;

    > * {
        min-width: 0;
    }

    @media (max-width: 480px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        row-gap: 12px;

        /* second row starts without a left divider */
        > *:nth-child(3) {
            border-left: 0;
        }
    }
`;

export const ScoreCell = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
    padding: 2px 8px;
    text-align: center;

    & + & {
        border-left: 1px solid #DAD7EE;
    }
`;

export const ScoreCellHead = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    text-align: left;
    color: #46506B;
    font-size: 10.5px;
    font-weight: 600;
    line-height: 1.25;

    .anticon {
        flex-shrink: 0;
        font-size: 16px;
        color: ${C.accent};
    }

    span {
        min-width: 0;
        overflow-wrap: anywhere;
    }
`;

export const ScoreCellValue = styled.div`
    font: 800 17px "Plus Jakarta Sans", "DM Sans", sans-serif;
    line-height: 1.2;
    white-space: nowrap;
    color: ${({ $tone }) =>
        $tone === "dark" ? C.ink : $tone === "muted" ? "#B3B8CB" : C.accent};
`;

export const RoundBadge = styled.span`
    display: inline-block;
    padding: 3px 16px;
    border-radius: 8px;
    background: #DDF5E5;
    color: #15803D;
    font: 800 15px "Plus Jakarta Sans", "DM Sans", sans-serif;
    line-height: 1.3;
`;

/* 5 · Footer: Expected CTC + View More */
export const CardFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px 16px;
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid #EDF0F7;
`;

export const CtcBlock = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    color: #46506B;
    font-size: 13px;

    .anticon {
        color: #6B6F8F;
        font-size: 18px;
        flex-shrink: 0;
    }

    .label {
        white-space: nowrap;
    }

    b {
        color: ${C.ink};
        font-weight: 800;
        white-space: nowrap;
    }
`;

export const ViewMoreButton = styled(PrimaryAction)`
    flex: 0 0 auto;
    min-width: 150px;
    height: 38px;
    padding: 0 18px;
    border-radius: 12px;
    font-size: 13px;
`;

/* Right side of the card footer: Generate AI Score + View More. */
export const FooterActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    margin-left: auto;
`;

/* Outline pill in the Coffeee purple, same height as View More. */
export const AiScoreButton = styled(PillButton)`
    height: 38px;
    border-radius: 12px;
    padding: 0 16px;
    font-size: 13px;
`;


export const FilterChipRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-top: 14px;
`;

export const FilterChipLabel = styled.span`
    font-size: 12px;
    color: ${C.muted};
    font-weight: 600;
    margin-right: 4px;
`;

export const CreatedStamp = styled.div`
    font-size: 11.5px;
    color: #9AA3BB;
    margin-top: 3px;
    line-height: 1.35;
`;

/* ── Temporary, frontend-only Save/shortlist toggle on the candidate card. ── */
export const SaveButton = styled.button`
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px solid ${({ $saved }) => ($saved ? "transparent" : C.fieldBorder)};
    background: ${({ $saved }) =>
        $saved ? `linear-gradient(135deg, ${C.gradientBtnFrom} 0%, ${C.gradientBtnTo} 100%)` : "#fff"};
    color: ${({ $saved }) => ($saved ? "#fff" : C.muted2)};
    font-weight: 700;
    font-size: 12px;
    padding: 5px 12px;
    border-radius: 999px;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover {
        border-color: ${({ $saved }) => ($saved ? "transparent" : "#B5AEF5")};
        color: ${({ $saved }) => ($saved ? "#fff" : C.accent)};
    }
`;

/* ── Empty / loading ── */
export const StatusCard = styled.div`
    background: #fff;
    border: 1px solid ${C.cardBorder};
    border-radius: 18px;
    padding: 65px 24px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const EmptyTitle = styled.h3`
    margin: 4px 0 6px;
    font-family: "Plus Jakarta Sans", "DM Sans", sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: ${C.ink};
`;

export const EmptyText = styled.p`
    margin: 0;
    color: ${C.muted3};
    font-size: 13px;
`;

/* ── Detail modal ── */
export const ModalCloseIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: ${C.chipBg};
    color: ${C.accent};
    font-size: 15px;
    transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

    .ant-modal-close:hover & {
        background: #DEDAFF;
        color: #3B30D6;
        box-shadow: 0 4px 12px rgba(77, 66, 233, 0.18);
    }

    .ant-modal-close:focus-visible & {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
    }
`;

export const ModalProfileRow = styled.div`
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 16px 18px;
    margin-right: 48px; /* keeps the header clear of the close button */
    background: ${C.detailCellBg};
    border: 1px solid ${C.cardBorder};
    border-radius: 16px;
`;

export const ModalName = styled.h2`
    margin: 7px 0 5px;
    font-family: "Plus Jakarta Sans", "DM Sans", sans-serif;
    font-weight: 800;
    font-size: 22px;
    color: ${C.ink};
    overflow-wrap: anywhere;
`;

export const ModalRoleCompany = styled.p`
    margin: 0;
    color: #78839F;
    font-size: 14px;
`;

export const ModalSection = styled.div`
    margin-top: 16px;
    padding: 16px 18px 18px;
    background: #fff;
    border: 1px solid ${C.cardBorder};
    border-radius: 16px;
`;

export const ModalContactRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 14px;
`;

export const ModalContactLink = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: ${C.accent};
    text-decoration: none;
    font-size: 13px;
    font-weight: 700;
    border: 1px solid ${C.fieldBorder};
    background: #fff;
    border-radius: 10px;
    padding: 7px 12px;
    cursor: pointer;

    &:hover {
        border-color: #B5AEF5;
        background: #F7F6FE;
        text-decoration: none;
    }
`;

export const DetailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
    margin-top: 14px;
`;

export const DetailCell = styled.div`
    background: ${C.detailCellBg};
    border: 1px solid ${C.cardBorder};
    border-radius: 12px;
    padding: 13px;
    min-width: 0;

    span {
        display: block;
        color: #8B95AD;
        font-size: 11px;
        margin-bottom: 5px;
    }

    b {
        color: #273154;
        font-size: 13px;
        overflow-wrap: anywhere;
    }
`;

/* ── Record card — calls / interviews / status timeline / AI skills in the modal. ── */
export const RecordCard = styled.div`
    background: ${C.detailCellBg};
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const RecordRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;

    b {
        color: #273154;
        font-size: 13px;
    }
`;

/* ── Pagination select (page-size dropdown) ── */
export const PaginationSelectWrapper = styled.div`
    .ant-select-selector {
        height: 34px !important;
        border-radius: 8px !important;
        border: 1px solid #E5E7EB !important;
        background: #FFFFFF !important;
        padding: 0 10px !important;
        display: flex !important;
        align-items: center !important;
        font-size: 13px !important;
        color: #374151 !important;
        box-shadow: none !important;
    }
    &:hover .ant-select-selector { border-color: #B5AEF5 !important; }
    .ant-select-focused .ant-select-selector { border-color: ${C.accent} !important; }
    .ant-select-selection-item { line-height: 34px !important; }
    .ant-select-arrow { color: #6B7280 !important; }
`;

export const PaginationBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px 4px 4px;
    margin-top: 8px;
`;

export const PaginationMeta = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 13px;
    color: #6B7280;
`;

export const PaginationControls = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const PageButton = styled.button`
    min-width: ${({ $nav }) => ($nav ? "auto" : "34px")};
    height: 34px;
    padding: ${({ $nav }) => ($nav ? "0 14px" : "0 10px")};
    border-radius: 8px;
    border: ${({ $active }) => ($active ? "none" : "1px solid #E5E7EB")};
    background: ${({ $active, disabled }) =>
        $active
            ? `linear-gradient(135deg, ${C.gradientBtnFrom} 0%, ${C.gradientBtnTo} 100%)`
            : disabled
            ? "#F9FAFB"
            : "#FFFFFF"};
    color: ${({ $active, disabled }) => ($active ? "#fff" : disabled ? "#D1D5DB" : "#374151")};
    font-weight: ${({ $active, $nav }) => ($active ? 600 : $nav ? 500 : 400)};
    font-size: 13px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    box-shadow: ${({ $active }) => ($active ? "0 2px 10px rgba(91,62,232,0.3)" : "none")};
`;

export const PageEllipsis = styled.span`
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9CA3AF;
    font-size: 14px;
    user-select: none;
`;

/* ── Labelled detail rows on the candidate card (older layout; no longer used) ── */
export const DetailRows = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const DetailRow = styled.div`
    display: grid;
    grid-template-columns: 82px minmax(0, 1fr);
    column-gap: 10px;
    align-items: start;
    font-size: 12.5px;
    line-height: 1.5;
`;

export const DetailRowLabel = styled.span`
    color: ${C.muted3};
    font-size: 12px;
`;

export const DetailRowValue = styled.span`
    min-width: 0;
    color: ${C.ink};
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SkillSep = styled.span`
    margin: 0 7px;
    color: #C3C9DA;
    font-weight: 400;
`;

/* ═════════════════════════════════════════════
   Prompt-style search (keyword + JD).
═════════════════════════════════════════════ */

export const JdCharCount = styled.div`
    margin-top: 6px;
    font-size: 11px;
    color: ${({ $error }) => ($error ? C.danger : "#9AA3BA")};
`;

export const ModeSwitch = styled.div`
    display: inline-flex;
    gap: 2px;
    padding: 4px;
    background: #F1F0FB;
    border-radius: 12px;
`;

export const ModeTab = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 0;
    border-radius: 9px;
    padding: 7px 14px;
    font: 600 13px "DM Sans", "Segoe UI", sans-serif;
    cursor: pointer;
    background: ${({ $active }) => ($active ? "#fff" : "transparent")};
    color: ${({ $active }) => ($active ? C.accent : C.muted2)};
    box-shadow: ${({ $active }) => ($active ? "0 2px 6px rgba(35, 27, 105, 0.1)" : "none")};
    transition: background 0.15s ease, color 0.15s ease;

    &:hover {
        color: ${C.accent};
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
    }

    @media (max-width: 520px) {
        padding: 7px 10px;

        .label {
            display: none;
        }
    }
`;

export const IconButton = styled.button`
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 1px solid ${C.fieldBorder};
    background: #fff;
    color: ${C.muted2};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease;

    &:hover:not(:disabled) {
        color: ${C.accent};
        border-color: #B5AEF5;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
    }
`;

export const SubmitButton = styled.button`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 0;
    background: linear-gradient(135deg, ${C.gradientBtnFrom}, ${C.gradientBtnTo});
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 8px 18px rgba(91, 62, 232, 0.28);
    transition: transform 0.15s ease, box-shadow 0.15s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 10px 22px rgba(91, 62, 232, 0.34);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        box-shadow: none;
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
    }
`;


export const ResultsBlock = styled.div`
    min-width: 0;
`;

/* CHANGED: the column now scrolls as a whole when its cards don't fit,
   instead of squeezing the Open demands card down to its title. */

/* Scrollable list inside a panel card. */
export const PanelList = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    ${({ $maxHeight }) => ($maxHeight ? `max-height: ${$maxHeight};` : "")}

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: #DCD8FB;
        border-radius: 10px;
    }
`;

export const PanelHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px 8px;
`;

export const PanelTitle = styled.h3`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    margin: 0;
    font: 700 14px "Plus Jakarta Sans", "DM Sans", sans-serif;
    color: ${C.ink};

    .anticon {
        color: ${C.accent};
    }
`;

export const PanelLink = styled.button`
    border: 0;
    background: none;
    padding: 2px 4px;
    color: ${C.muted2};
    font: 600 12px "DM Sans", "Segoe UI", sans-serif;
    cursor: pointer;

    &:hover {
        color: ${C.accent};
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
        border-radius: 4px;
    }
`;

export const PanelEmpty = styled.p`
    margin: 0;
    padding: 6px 8px 8px;
    color: ${C.muted3};
    font-size: 12.5px;
`;

export const PanelItem = styled.button`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    width: 100%;
    border: 0;
    background: transparent;
    padding: 7px 8px;
    border-radius: 10px;
    text-align: left;
    cursor: pointer;
    transition: background 0.12s ease;

    &:hover:not(:disabled) {
        background: #EFEEFB;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.55;
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: -2px;
    }
`;

export const PanelItemTitle = styled.span`
    max-width: 100%;
    color: #293451;
    font: 500 13.5px "DM Sans", "Segoe UI", sans-serif;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const PanelItemMeta = styled.span`
    max-width: 100%;
    color: #9AA3BA;
    font-size: 11.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;


/* ── Removable "searching for" chips ── */
export const RemovableChip = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: ${C.chipBg};
    color: ${C.chipText};
    border: 0;
    border-radius: 999px;
    padding: 5px 8px 5px 10px;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.12s ease;

    .anticon {
        font-size: 10px;
        opacity: 0.65;
    }

    &:hover {
        background: #E0DDFC;
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
    }
`;

/* ── Open-demands filter + end-of-list ── */
export const PanelFilter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 8px 8px;
`;

export const PanelSearchWrap = styled.div`
    .ant-input-affix-wrapper {
        border-radius: 10px !important;
        border-color: ${C.fieldBorder} !important;
        background: ${C.detailCellBg} !important;
        box-shadow: none !important;
        min-height: 34px;
        padding: 4px 10px !important;
    }

    .ant-input-affix-wrapper-focused {
        border-color: ${C.fieldFocusBorder} !important;
        box-shadow: 0 0 0 3px rgba(89, 79, 240, 0.1) !important;
        background: #fff !important;
    }

    .ant-input {
        background: transparent !important;
        font-size: 12.5px !important;
    }
`;

export const MiniChipRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
`;

export const MiniChip = styled.button`
    border: 1px solid ${({ $active }) => ($active ? "#C4BFFF" : C.cardBorder)};
    background: ${({ $active }) => ($active ? C.chipBg : "#fff")};
    color: ${({ $active }) => ($active ? C.chipText : C.muted2)};
    border-radius: 999px;
    padding: 2px 9px;
    font: 600 11px "DM Sans", "Segoe UI", sans-serif;
    cursor: pointer;
    transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;

    &:hover {
        border-color: #C4BFFF;
        color: ${C.chipText};
    }
`;

/* Sits at the bottom of leftover list space (margin-top: auto). */
export const PanelListEnd = styled.div`
    margin-top: auto;
    padding: 16px 8px 12px;
    border-top: 1px dashed #D9DCEC;
    color: #9AA3BA;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    text-align: center;
`;

export const PanelFooter = styled.div`
    flex-shrink: 0;
    margin: 0 -10px;
    padding: 9px 18px 10px;
    border-top: 1px solid ${C.cardBorder};
    background: ${C.detailCellBg};
    color: ${C.muted2};
    font-size: 11.5px;
    font-weight: 600;
    text-align: center;
    border-radius: 0 0 16px 16px;
`;

/* ── Refine-results card (right panel, after a search) ── */
export const RefineGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 9px;
    padding: 0 8px 4px;
    overflow-y: auto;
    min-height: 0;
    max-height: 280px;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: #DCD8FB;
        border-radius: 10px;
    }
`;

export const RefineLabel = styled.span`
    display: block;
    margin-bottom: 4px;
    color: ${C.muted2};
    font-size: 11px;
    font-weight: 700;
`;

export const RefinePair = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 6px;
    align-items: center;
`;

export const RefineSep = styled.span`
    color: #9AA3BA;
    font-size: 11px;
`;

export const CompactField = styled.div`
    min-width: 0;

    .ant-input,
    .ant-input-number,
    .ant-select-selector {
        border-radius: 9px !important;
        border-color: ${C.fieldBorder} !important;
        box-shadow: none !important;
        font-size: 12.5px !important;
        min-height: 34px !important;
    }

    .ant-input {
        padding: 4px 10px !important;
    }

    .ant-input-number {
        width: 100%;
    }

    .ant-input-number-input {
        height: 32px !important;
        font-size: 12.5px !important;
    }

    .ant-select {
        width: 100%;
    }

    .ant-select-selector {
        min-height: 34px !important;
        height: auto !important;
        padding: 2px 8px !important;
    }

    .ant-select-selection-overflow {
        min-height: 28px;
    }

    .ant-input:hover,
    .ant-input-number:hover,
    .ant-select:hover .ant-select-selector {
        border-color: #B5AEF5 !important;
    }

    .ant-input:focus,
    .ant-input-focused,
    .ant-input-number-focused,
    .ant-select-focused .ant-select-selector {
        border-color: ${C.fieldFocusBorder} !important;
        box-shadow: 0 0 0 3px rgba(89, 79, 240, 0.1) !important;
    }
`;

export const RefineActions = styled.div`
    display: flex;
    gap: 8px;
    padding: 10px 8px 12px;

    button {
        flex: 1;
        height: 34px;
        border-radius: 9px;
        font-weight: 700;
        font-size: 12.5px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
    }
`;

export const RefineApply = styled.button`
    border: 0;
    background: linear-gradient(135deg, ${C.gradientBtnFrom}, ${C.gradientBtnTo});
    color: #fff;
    box-shadow: 0 6px 14px rgba(91, 62, 232, 0.22);

    &:hover:not(:disabled) {
        transform: translateY(-1px);
    }

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
        box-shadow: none;
    }
`;

export const RefineReset = styled.button`
    border: 1px solid ${C.fieldBorder};
    background: #fff;
    color: ${C.muted2};

    &:hover:not(:disabled) {
        border-color: #B5AEF5;
        color: ${C.accent};
    }

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
`;

/* ═════════════════════════════════════════════
   ChatGPT-style layout, Coffeee palette: header with top-right
   buttons that open pop-overs, a centered composer before the first
   search, and a + menu inside the composer.
═════════════════════════════════════════════ */

/* ── Header row with the top-right buttons ── */
export const TopBar = styled.div`
    position: relative;
    z-index: 20; /* pop-overs sit above the results */
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 8px;
`;

export const TopActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 6px;
`;

export const PopoverAnchor = styled.div`
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
`;

export const TopButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 16px;
    border-radius: 12px;
    border: 1px solid ${({ $active }) => ($active ? "#C4BFFF" : C.fieldBorder)};
    background: ${({ $active }) => ($active ? C.chipBg : "#fff")};
    color: ${({ $active }) => ($active ? C.chipText : C.ink)};
    font: 600 13px "DM Sans", "Segoe UI", sans-serif;
    cursor: pointer;
    box-shadow: 0 6px 16px rgba(37, 32, 92, 0.05);
    transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;

    .anticon {
        font-size: 15px;
        color: ${C.accent};
    }

    &:hover {
        border-color: #B5AEF5;
        color: ${C.accent};
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
    }

    @media (max-width: 640px) {
        padding: 0 12px;

        .label {
            display: none;
        }
    }
`;

export const DirtyDot = styled.span`
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${C.accent};
`;

/* Floating panel under a top-right button — same look as the old side-panel cards. */
export const Popover = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 1100;
    width: min(${({ $width }) => $width || 340}px, calc(100vw - 32px));
    ${({ $tall }) => ($tall ? "height: min(72vh, 640px);" : "max-height: min(70vh, 560px);")}
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    border: 1px solid ${C.cardBorder};
    border-radius: 16px;
    padding: 12px 10px 0;
    box-shadow: 0 20px 50px rgba(24, 33, 61, 0.16);
    animation: coffeeePopIn 0.14s ease-out;

    @keyframes coffeeePopIn {
        from {
            opacity: 0;
            transform: translateY(-4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

/* ── Search stage: centered before the first search ── */
export const SearchStage = styled.div`
    width: 100%;
    /* Before the first search the composer is compact; after a search it
       keeps its previous width. The results block is a separate component
       and is not affected by this. */
    max-width: ${({ $centered }) => ($centered ? "760px" : "1180px")};
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    ${({ $centered }) =>
        $centered
            ? `
        min-height: calc(100vh - 170px);
        justify-content: center;
        padding-bottom: 12vh;
    `
            : `
        margin-top: 8px;
        margin-bottom: 22px;
    `}
`;

export const Hero = styled.div`
    text-align: center;
    margin-bottom: 26px;
`;

export const HeroTitle = styled.h2`
    margin: 0 0 6px;
    font: 800 28px "Plus Jakarta Sans", "DM Sans", sans-serif;
    color: ${C.ink2};

    @media (max-width: 640px) {
        font-size: 23px;
    }
`;

export const HeroSubtitle = styled.p`
    margin: 0;
    color: ${C.muted};
    font-size: 15px;
`;

/* ── Composer ── */
export const Composer = styled.div`
    position: relative;
    z-index: 10; /* + menu above the chips below */
    background: ${({ $dragging }) => ($dragging ? "#F7F6FE" : "#fff")};
    border: 1px ${({ $dragging }) => ($dragging ? "dashed" : "solid")}
        ${({ $dragging }) => ($dragging ? C.fieldFocusBorder : C.searchCardBorder)};
    border-radius: 999px;
    padding: 8px 10px;
    box-shadow: 0 14px 34px rgba(35, 27, 105, 0.08);

    /* Back to a rounded rectangle once chips sit above the input. */
    &:has(> [data-attachments]) {
        border-radius: 22px;
    }
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

    &:focus-within {
        border-color: #B5AEF5;
        box-shadow: 0 14px 34px rgba(35, 27, 105, 0.1), 0 0 0 3px rgba(89, 79, 240, 0.1);
    }
`;

export const ComposerAttachments = styled.div.attrs({ "data-attachments": true })`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 2px 4px 8px;
`;

export const AttachmentChip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 300px;
    padding: 4px 6px 4px 10px;
    border-radius: 10px;
    border: 1px solid ${C.fieldBorder};
    background: ${C.detailCellBg};
    color: #293451;
    font: 600 12.5px "DM Sans", "Segoe UI", sans-serif;

    .anticon {
        color: ${C.accent};
        flex-shrink: 0;
    }

    .name {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

// Small preview of an attached JD image inside its chip.
export const AttachmentThumb = styled.img`
    width: 26px;
    height: 26px;
    border-radius: 6px;
    object-fit: cover;
    flex-shrink: 0;
`;

export const ChipRemove = styled.button`
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: ${C.muted2};
    cursor: pointer;

    .anticon {
        font-size: 10px;
        color: inherit;
    }

    &:hover {
        background: rgba(77, 66, 233, 0.1);
        color: ${C.accent};
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 1px;
    }
`;

export const ComposerRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const PlusButton = styled.button`
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ $active }) => ($active ? "#C4BFFF" : C.cardBorder)};
    border-radius: 50%;
    background: ${({ $active }) => ($active ? C.chipBg : "#fff")};
    color: ${C.accent};
    font-size: 17px;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover:not(:disabled) {
        background: #F1F0FB;
        border-color: #C4BFFF;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: 2px;
    }
`;

export const PlusMenu = styled.div`
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 1100;
    width: 260px;
    max-width: calc(100vw - 32px);
    padding: 6px;
    background: #fff;
    border: 1px solid ${C.cardBorder};
    border-radius: 14px;
    box-shadow: 0 20px 50px rgba(24, 33, 61, 0.16);
    animation: coffeeePopIn 0.14s ease-out;
`;

export const PlusMenuItem = styled.button`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 8px;
    border: 0;
    border-radius: 10px;
    background: transparent;
    text-align: left;
    cursor: pointer;
    color: #293451;
    font: 600 13px "DM Sans", "Segoe UI", sans-serif;

    small {
        display: block;
        margin-top: 1px;
        color: #9AA3BA;
        font-weight: 500;
        font-size: 11.5px;
    }

    &:hover:not(:disabled) {
        background: #EFEEFB;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.55;
    }

    &:focus-visible {
        outline: 2px solid ${C.fieldFocusBorder};
        outline-offset: -2px;
    }
`;

export const PlusMenuIcon = styled.span`
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 9px;
    background: ${C.detailCellBg};
    color: ${C.accent};
    font-size: 15px;
`;

export const ComposerInput = styled.div`
    flex: 1 1 200px;
    min-width: 0;

    textarea.ant-input {
        border: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
        padding: 8px 4px !important;
        resize: none !important;
        font: 400 15px/1.5 "DM Sans", "Segoe UI", sans-serif !important;
        color: ${C.ink};
    }

    textarea.ant-input::placeholder {
        color: #9AA3BA;
    }

`;

export const ComposerActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: auto;
`;

/* ── Older card tiles (Round / Tech / AI) — superseded by the ScorePanel
   above; kept so nothing that imports them breaks. ── */
const SCORE_TILE_HEIGHT = 56; // px

export const ScoreTiles = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    align-items: stretch;
    margin-top: 12px;
    padding: 12px 0;
    border-top: 1px solid #EDF0F7;
    border-bottom: 1px solid #EDF0F7;

    /* Never let a tile (or a Tooltip wrapper) grow past its own column. */
    > * {
        min-width: 0;
        width: 100%;
        box-sizing: border-box;
    }

    ${({ $empty }) => ($empty ? "margin-top: 0; padding: 0; border: 0;" : "")}

    @supports not (grid-template-rows: subgrid) {
        margin-top: auto;
    }
`;

const TILE_TONES = {
    green: { bg: "#ECF9F0", icon: "#16A34A", text: "#15803D" },
    blue: { bg: "#EEF3FF", icon: "#3B6BF0", text: "#2F5BD8" },
    pink: { bg: "#FDEFF4", icon: "#E5487C", text: "#DB2764" },
};

export const ScoreTileLabel = styled.div`
    color: ${C.muted2};
    font-size: 10.5px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ScoreTileValue = styled.div`
    font: 800 ${({ $big }) => ($big ? "16px" : "15px")} "Plus Jakarta Sans", "DM Sans", sans-serif;
    line-height: 1.2;
    color: inherit;
`;

/* Round tile: icon + "R2", centered. Score tiles: label on its own line,
   then icon + value — so "Tech Score" fits even in a one-third-width card. */
export const ScoreTile = styled.div`
    min-width: 0;
    min-height: ${SCORE_TILE_HEIGHT}px;
    box-sizing: border-box;
    padding: 8px 10px;
    border-radius: 10px;
    background: ${({ $tone }) => (TILE_TONES[$tone] || TILE_TONES.blue).bg};
    color: ${({ $tone }) => (TILE_TONES[$tone] || TILE_TONES.blue).text};
    ${({ $tone }) =>
        $tone === "green"
            ? `
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
    `
            : `
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
        grid-template-areas: "label label" "icon value";
        align-items: center;
        column-gap: 6px;
        row-gap: 2px;

        > div {
            display: contents;
        }
    `}

    .tile-icon {
        grid-area: icon;
        font-size: 16px;
        color: ${({ $tone }) => (TILE_TONES[$tone] || TILE_TONES.blue).icon};
        flex-shrink: 0;
    }

    ${ScoreTileLabel} {
        grid-area: label;
    }

    ${ScoreTileValue} {
        grid-area: value;
    }
`;

/* ── Candidate popup ("View more") ── */
export const SectionHeadRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;

    button:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        transform: none;
    }
`;

/* AI Assessment: "Scored against …" on the left, Generate button on the right. */
export const SourceActionRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;

    /* the line keeps its ellipsis, the button never shrinks */
    > p {
        flex: 1 1 200px;
        min-width: 0;
        margin: 0;
    }

    > button {
        flex-shrink: 0;
        margin-left: auto;
    }

    button:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        transform: none;
    }
`;

export const InlineScoreBadge = styled.span`
    background: ${C.chipBg};
    color: ${C.chipText};
    font-weight: 800;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 999px;
    white-space: nowrap;
    cursor: default;
`;

export const ModalActionRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 14px;

    button:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        transform: none;
    }
`;

export const StatusNote = styled.div`
    display: inline-block;
    margin-top: 12px;
    padding: 6px 12px;
    border-radius: 10px;
    background: ${C.detailCellBg};
    border: 1px solid ${C.cardBorder};
    color: ${C.muted2};
    font-size: 13px;
    font-weight: 600;
`;

export const AiSourceLine = styled.p`
    margin: 10px 0 0;
    color: ${C.muted};
    font-size: 12.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    b {
        color: ${C.ink};
        font-weight: 600;
    }
`;

export const CertList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const CertItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 12px;
    background: ${C.detailCellBg};

    .anticon {
        color: ${C.accent};
        font-size: 16px;
        margin-top: 2px;
    }

    b {
        display: block;
        color: #273154;
        font-size: 13px;
    }

    small {
        color: ${C.muted3};
        font-size: 11.5px;
    }
`;